// extracted by mini-css-extract-plugin
module.exports = {"desktop":"style_desktop__0lVCI","mobile":"style_mobile__GP35j"};